<template lang="html">
  <transition name="navigation">
    <div
      class="navigation"
      :class="{'time-is-almost-up': applyWarningColors}"
    >
      <div class="col-left">
        <!-- <a
          href="#"
          aria-label="Show About and Support information"
          class="button with-label icon-left info info-style"
          :class="applyWarningColors ? 'tertiary-dark info--dark' : 'tertiary-primary info--primary'"
          @click.stop="onInfo($event)"
          @touchstart=""
        > -->
          <a
          href="/info"
          aria-label="Show About and Support information"
          class="button with-label icon-left info info-style"
          :class="applyWarningColors ? 'tertiary-dark info--dark' : 'tertiary-primary info--primary'"
        >
          <span>Info</span>
        </a>
        <!-- <a
          href="#"
          aria-label="Show preferences"
          class="button with-label icon-left preferences"
          :class="applyWarningColors ? 'tertiary-dark preferences--dark' : 'tertiary-primary preferences--primary'"
          @click.stop="onSettings($event)"
          @touchstart=""
        > -->
          <a
          href="/preferences"
          aria-label="Show preferences"
          class="button with-label icon-left preferences"
          :class="applyWarningColors ? 'tertiary-dark preferences--dark' : 'tertiary-primary preferences--primary'"
        >
          <span>Preferences</span>
        </a>
        <a
          href="/blog"
          aria-label="View Blog"
          class="button with-label icon-left preferences"
          :class="applyWarningColors ? 'tertiary-dark preferences--dark' : 'tertiary-primary preferences--primary'"
        >
          <span>Blog</span>
        </a>
      </div>
      <div class="col-right">
        <label
          class="label with-toggle repeat"
          :class="applyWarningColors ? 'dark' : 'light'"
        >
          <span class="span">Repeat</span>
          <input
            class=""
            :class="applyWarningColors ? 'switch-dark' : 'switch-primary'"
            type="checkbox"
            v-model="repeatSettingModel"
      			@touchstart=""
          >
        </label>
        <button
          aria-label="Toggle fullscreen"
          v-if="fullscreenSupport || isIOS"
          class="button with-label icon-right tertiary-primary fullscreen-toggle"
          :class="applyWarningColors ? 'fullscreen-switch-dark' : 'fullscreen-switch-primary'"
          @click.stop="onFullscreen"
          @touchstart=""
        >
          <span>Fullscreen</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "TheNavigation",

  props: {
    fullscreen: {
      // Sets a class on the fullscreen button, changing its icon.
      type: Boolean,
      required: true,
    },
    settingRepeat: {
      // Boolean, but is allowed to be undefined
      required: true,
    },
    applyWarningColors: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      repeatSettingModel: this.settingRepeat,
    };
  },

  computed: {
    isIOS() {
      const iDevices = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ];
      if (navigator.platform) {
        while (iDevices.length) {
          if (navigator.platform === iDevices.pop()) {
            return true;
          }
        }
      }
      return false;
    },

    fullscreenSupport() {
      if (document.fullscreenElement !== undefined) {
        return true;
      } else if (document.webkitFullscreenElement !== undefined) {
        return true;
      } else if (document.mozFullScreenElement !== undefined) {
        return true;
      } else if (document.msFullscreenElement !== undefined) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    onInfo(e) {
      e.preventDefault();
      this.$router.push({ name: "info" });
      _paq.push(["trackEvent", "Navigation", "Show Info"]);
    },
    onSettings(e) {
      e.preventDefault();
      this.$router.push({ name: "preferences" });
      _paq.push(["trackEvent", "Navigation", "Show Settings"]);
    },
    onFullscreen() {
      if (this.isIOS) {
        this.$emit("showTipFullscreenOnIOS");
      } else {
        // Event is tracked in App.vue.
        this.$emit("toggleFullscreen");
      }
    },
  },

  watch: {
    settingRepeat(newVal) {
      this.repeatSettingModel = newVal;
    },
    repeatSettingModel(newVal) {
      this.$emit("update:settingRepeat", newVal);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../style/abstracts/variables.scss";
@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";

.navigation {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  width: 100vw;
  overflow: hidden;
  padding: $small + rem;
  padding-top: env(safe-area-inset-top); // iPhone X safe area
  pointer-events: none;
  overflow: visible;
  user-select: none;

  // Move navigation bar a bit below the iOS status bar in fullscreen mode.
  @media screen and (min-height: 350px) {
    top: $medium + rem;
  }

  @include break-padding-1-h {
    right: $default + rem;
    left: $default + rem;
    width: auto;
  }
  @include break-padding-1-v {
    // top: $default + rem;
    top: 0%;
  }

  .col-left,
  .col-right {
    flex: 1;

    .button,
    .label {
      pointer-events: auto; // Seems to cause issues in Firefox, but only sometimes.
    }
  }
  .col-right {
    display: flex;
    justify-content: flex-end;
  }

  .button.info,
  .button.preferences,
  .button.fullscreen-toggle {
    padding: 0;
    width: $button-size-small-screen + rem;
    background-position: center center;

    span {
      display: none;
    }
  }

  @include break-padding-1-h {
    .button.info,
    .button.preferences,
    .button.fullscreen-toggle {
      width: auto;

      span {
        display: inline;
      }
    }
    .button.info,
    .button.preferences {
      padding-right: $medium + rem;
      padding-left: $large - $small + rem;
      background-position: left center;
    }
    .button.fullscreen-toggle {
      padding-right: $large + $small + rem;
      background-position: right center;
    }
  }
}

.label.repeat, // Repeat toggle
.button.fullscreen-toggle {
  margin-left: $medium + rem;

  @include break-large-ui {
    margin-left: $default + rem;
  }
}

.button.info--primary {
  background-image: url("../assets/images/Icon/Info/Main.svg");
}
.button.info--dark {
  background-image: url("../assets/images/Icon/Info/Dark.svg");
}
.button.preferences--primary {
  background-image: url("../assets/images/Icon/Preferences/Main.svg");
}
.button.preferences--dark {
  background-image: url("../assets/images/Icon/Preferences/Dark.svg");
}
.fullscreen-switch-primary {
  background-image: url("../assets/images/Icon/EnterFullscreen/Main.svg");
}
.fullscreen-switch-dark {
  color: $color-dark;
  background-image: url("../assets/images/Icon/EnterFullscreen/Dark.svg");
}
div:fullscreen {
  .fullscreen-switch-primary,
  .fullscreen-switch-dark {
    .no-touch-events &:hover {
      transform: none;
      background-size: (0.85 * $large) + rem (0.85 * $large) + rem;
    }
  }
  .fullscreen-switch-primary {
    background-image: url("../assets/images/Icon/ExitFullscreen/Main.svg");
  }
  .fullscreen-switch-dark {
    background-image: url("../assets/images/Icon/ExitFullscreen/Dark.svg");
  }
}
// Add overlay to navigation items covering the timer
@media screen and (min-width: 750px) and (min-aspect-ratio: 1200/375) {
  .button.info,
  .button.preferences,
  .label.repeat {
    background-color: transparentize($color-very-dark, 0.2);
    border-radius: $large + rem;
  }
  .label.repeat {
    padding-left: $default + rem;
  }
  .switch-primary {
    background: $color-very-dark; // Because it can cover the timer
  }
  .time-is-almost-up {
    .button.info,
    .button.preferences,
    .label.repeat {
      background-color: transparentize($color-primary, 0.2);
    }
    .switch-primary {
      background: $color-primary; // Because it can cover the timer
    }
  }
}
// Transitions
//////////////

.with-motion {
  .navigation-enter-active {
    @include enter-active-transitions-for-controls;
  }
  .navigation-leave-active {
    @include leave-active-transition-for-controls;
  }
}

.navigation-enter-to,
.navigation-leave {
  opacity: 1;
  transform: translateY(0);
}

.navigation-enter,
.navigation-leave-to {
  opacity: 0;
  transform: translateY(
    -1 * $button-size-small-screen + rem
  ); // margin + button size
}

@include break-padding-1-h {
  .navigation-enter,
  .navigation-leave-to {
    opacity: 0;
    transform: translateY(-1 * $default + rem); // margin + button size
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TheNavigation.vue